export default "__VITE_PUBLIC_ASSET__ef4eb0b1__"